import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Panel, PanelContent } from '@/components/ui/panel';
import { logger } from '@/lib/telemetry/logger';
export function PartnerLoadError(t0) {
  const $ = _c(13);
  const {
    onRetry
  } = t0;
  const t = useTranslations("profile.partner");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("load_error");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <p>{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("retry");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onRetry || $[8] !== t4) {
    t5 = <AnimatedButton variant="secondary" onClick={onRetry}>{t4}</AnimatedButton>;
    $[7] = onRetry;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <Panel><PanelContent><div role="alert" className="flex flex-wrap items-center justify-between gap-3 text-body">{t3}{t5}</div></PanelContent></Panel>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp() {
  logger.warn("portfolio.partner_profile.load_failed", {
    stage: "public_profile"
  });
}